import { LayoutDashboard, Package, Network, LayoutGrid, Store, FileText } from "lucide-react";
import { AdminShell, AdminForbiddenPage } from "@trillion/auth";
import type { NavItem } from "@trillion/ui/components/app-sidebar";
import { RootLayout } from "../layouts/root-layout";
import { LoginPage } from "../pages/login";
import { DashboardPage } from "../pages/dashboard";
import { ProductsPage } from "../pages/products";
import { ProductNewPage } from "../pages/product-new";
import { ProductEditPage } from "../pages/product-edit";
import { NetworksPage } from "../pages/networks";
import { NetworkNewPage } from "../pages/network-new";
import { NetworkEditPage } from "../pages/network-edit";
import { PlacementsPage } from "../pages/placements";
import { PlacementNewPage } from "../pages/placement-new";
import { PlacementEditPage } from "../pages/placement-edit";
import { BrandsPage } from "../pages/brands";
import { BrandNewPage } from "../pages/brand-new";
import { BrandEditPage } from "../pages/brand-edit";
import { ArticlesPage } from "../pages/articles";
import { ArticleNewPage } from "../pages/article-new";
import { ArticleEditPage } from "../pages/article-edit";

const navItems: NavItem[] = [
  { label: "Dashboard", href: "/", icon: LayoutDashboard },
  { label: "Products", href: "/products", icon: Package },
  { label: "Networks", href: "/networks", icon: Network },
  { label: "Placements", href: "/placements", icon: LayoutGrid },
  { label: "Brands", href: "/brands", icon: Store },
  { label: "Articles", href: "/articles", icon: FileText },
];

export const routes = [
  {
    element: <RootLayout />,
    children: [
      { path: "/login", element: <LoginPage /> },
      { path: "/forbidden", element: <AdminForbiddenPage /> },
      {
        element: <AdminShell appName="Help Admin" navItems={navItems} product="help" />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: "/products", element: <ProductsPage /> },
          { path: "/products/new", element: <ProductNewPage /> },
          { path: "/products/:id", element: <ProductEditPage /> },
          { path: "/networks", element: <NetworksPage /> },
          { path: "/networks/new", element: <NetworkNewPage /> },
          { path: "/networks/:id", element: <NetworkEditPage /> },
          { path: "/placements", element: <PlacementsPage /> },
          { path: "/placements/new", element: <PlacementNewPage /> },
          { path: "/placements/:id", element: <PlacementEditPage /> },
          { path: "/brands", element: <BrandsPage /> },
          { path: "/brands/new", element: <BrandNewPage /> },
          { path: "/brands/:id", element: <BrandEditPage /> },
          { path: "/articles", element: <ArticlesPage /> },
          { path: "/articles/new", element: <ArticleNewPage /> },
          { path: "/articles/:id", element: <ArticleEditPage /> },
        ],
      },
    ],
  },
];
